// src/pages/ScanDashboard.jsx
import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ScanDashboard.css";
import TemplateModal from "../components/TemplateModal/TemplateModal";
import Toast from "../components/Toast/Toast";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import CreateTemplateModal from "../components/CreateTemplateModal/CreateTemplateModal";
import TemplateManagerModal from "../components/TemplateManagerModal/TemplateManagerModal";

// --- THÊM IMPORT KÉO THẢ ---
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

// ====== KHAI BÁO DANH SÁCH FILE CÓ SẴN ======
const INPUT_FILES = [
  "Screenshot 2025-11-25 141337.png",
  "Screenshot 2025-11-25 141352.png",
  "Screenshot 2025-11-25 141405.png",
  "Screenshot 2025-11-25 141418.png",
];

export default function ScanDashboard() {
  const [openModal, setOpenModal] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const [currentSession, setCurrentSession] = useState(null);
  const [allImageUrls, setAllImageUrls] = useState([]);

  // URL của ảnh đang được hiển thị ở giữa
  const [selectedImage, setSelectedImage] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [selectedDocIndex, setSelectedDocIndex] = useState(null);
  const [fieldsEditable, setFieldsEditable] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openManagerModal, setOpenManagerModal] = useState(false);
  const [ocrDone, setOcrDone] = useState(false);
  const [ocrMode, setOcrMode] = useState("default");

  const wrapperRef = useRef(null);
  const imageRef = useRef(null);
  const scanTimersRef = useRef([]);
  const confirmTimerRef = useRef(null);
  const initialTimerRef = useRef(null);
  const lastPageAtRef = useRef(0);
  const pendingInitialDocsRef = useRef(null);
  const fullUrlsRef = useRef([]);
  const imagesRef = useRef([]); // store { blob, url } for current scan session
  const finalizingRef = useRef(false); // when true, ignore incoming WS frames
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const wsRef = useRef(null);
  const [wsConnected, setWsConnected] = useState(false);
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const [globalLoading, setGlobalLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [templateFields, setTemplateFields] = useState([]);

  // WebSocket config
  const WS_URL = "ws://localhost:8080/ws";
  const WS_TOKEN = process.env.REACT_APP_SCAN_WS_TOKEN || "CHANGE_ME_SECRET";

  // ================== TEMPLATE ==================
  const handleSelectTemplate = (data) => {
    fetch("https://api.ocr.cybertech.com.vn/sessions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        package_id: data.templateId,
        name: data.batchName || "",
      }),
    })
      .then((res) => res.json())
      .then((session) => {
        console.log("Session created:", session);
        setCurrentSession(session);
        setToastMsg("Tạo phiên quét thành công");
        setTemplateFields(session.indexes || []);

        // Reset
        setDocuments([]);
        setSelectedDocIndex(null);
        setSelectedImage(null);
        setAllImageUrls([]);
        setFieldsEditable(false);
      })
      .catch((e) => {
        console.error(e);
        setToastMsg("Tạo phiên quét thất bại");
      });
  };

  // ================== API CẬP NHẬT CẤU TRÚC (MỚI) ==================
  const updateStructureAPI = async (newDocuments) => {
    if (!currentSession) return;

    // Biến đổi state documents thành mảng lồng nhau [[0,1], [2]]
    const newStructure = newDocuments.map(doc => doc.indices);

    try {
      const res = await fetch(
        `https://api.ocr.cybertech.com.vn/sessions/${currentSession._id}/structure`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            document_structure: newStructure
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        console.error("Lỗi update structure:", data);
        setToastMsg("Cập nhật cấu trúc thất bại");
      } else {
        console.log("Cập nhật cấu trúc thành công:", data);
      }
    } catch (error) {
      console.error(error);
      setToastMsg("Lỗi kết nối khi cập nhật cấu trúc");
    }
  };

  // ================== XỬ LÝ KÉO THẢ (MỚI) ==================
  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    // 1. Clone mảng documents
    let newDocuments = JSON.parse(JSON.stringify(documents)); // Deep clone để an toàn

    const sourceDocIndex = parseInt(source.droppableId.replace("doc-", ""));
    const sourceDoc = newDocuments.find((d) => d.doc_index === sourceDocIndex);

    if (!sourceDoc) return;

    // 2. Lấy trang đang được kéo ra khỏi nguồn
    const [movedPageIndex] = sourceDoc.indices.splice(source.index, 1);

    // 3. Xử lý điểm đến
    if (destination.droppableId === "create-new-doc") {
      // === Kéo xuống vùng tạo mới ===
      const newDoc = {
        doc_index: newDocuments.length, // Tạm thời lấy length, tí sẽ re-index lại
        indices: [movedPageIndex],
        fields: templateFields.map((f) => ({ ...f, value: "" })),
      };
      newDocuments.push(newDoc);
    } else {
      // === Kéo vào tài liệu đã có ===
      const destDocIndex = parseInt(destination.droppableId.replace("doc-", ""));
      const destDoc = newDocuments.find((d) => d.doc_index === destDocIndex);

      if (destDoc) {
        destDoc.indices.splice(destination.index, 0, movedPageIndex);
      } else {
        // Fallback: Trả lại chỗ cũ nếu lỗi
        sourceDoc.indices.splice(source.index, 0, movedPageIndex);
        return;
      }
    }

    // =======================================================
    // 4. CLEANUP: Xóa tài liệu rỗng & Đánh lại số thứ tự
    // =======================================================

    // Lọc bỏ những tài liệu không còn trang nào (indices rỗng)
    newDocuments = newDocuments.filter((doc) => doc.indices.length > 0);

    // Map lại doc_index để đảm bảo thứ tự luôn là 0, 1, 2... 
    // (Tránh trường hợp còn Tài liệu 1 và Tài liệu 3 nhưng mất Tài liệu 2)
    newDocuments = newDocuments.map((doc, index) => ({
      ...doc,
      doc_index: index
    }));

    // 5. Cập nhật State & API
    setDocuments(newDocuments);
    setSelectedImage(allImageUrls[movedPageIndex]); // Highlight trang vừa kéo

    // Nếu tài liệu đang chọn bị xóa mất (do rỗng), reset selection về null hoặc về doc đầu tiên
    if (!newDocuments.find(d => d.doc_index === selectedDocIndex)) {
      if (newDocuments.length > 0) setSelectedDocIndex(0);
      else setSelectedDocIndex(null);
    }

    updateStructureAPI(newDocuments);
  };

  // ================== SCAN ==================
  const handleScan = async () => {
    if (!currentSession) {
      setToastMsg("Bạn phải chọn Template trước!");
      return;
    }

    if (!wsRef.current || !wsConnected) {
      setToastMsg("Chưa kết nối tới scanner");
      return;
    }

    if (!selectedDevice) {
      setToastMsg("Bạn phải chọn máy scan trước khi bắt đầu");
      return;
    }

    // Prevent starting a new scan while we're finalizing/uploading previous session
    if (finalizingRef.current) {
      setToastMsg("Đang xử lý phiên trước, vui lòng chờ một chút");
      return;
    }

    // If we are currently paused, treat this as a resume: don't clear collected images
    if (isPaused) {
      setIsPaused(false);
      setIsScanning(true);
      setGlobalLoading(true);
      setLoadingText("Đang tiếp tục scan...");
      try {
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
          wsRef.current.send(JSON.stringify({
            type: "scan",
            token: WS_TOKEN,
            device: selectedDevice,
            source: "glass",
            dpi: 200,
            bitdepth: "color",
          }));
        } else {
          setToastMsg("Máy scan chưa sẵn sàng (WS chưa mở)");
          setGlobalLoading(false);
          setIsScanning(false);
        }
      } catch (err) {
        console.error(err);
        setToastMsg("Không thể tiếp tục scan");
        setGlobalLoading(false);
        setIsScanning(false);
      }
      return;
    }

    // Start WS scan
    try {
      setIsScanning(true);
      setGlobalLoading(true);
      setLoadingText("Đang scan...");

      // Clear previous state & revoke any previous object URLs
      if (imagesRef.current && imagesRef.current.length) {
        imagesRef.current.forEach((it) => {
          try { if (it && it.url) URL.revokeObjectURL(it.url); } catch (e) {}
        });
      }
      imagesRef.current = [];
      setDocuments([]);
      setAllImageUrls([]);
      setSelectedDocIndex(null);
      setSelectedImage(null);

      // send scan command to WS server
      // ensure WS is open before sending
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({
          type: "scan",
          token: WS_TOKEN,
          device: selectedDevice,
          source: "glass",
          dpi: 200,
          bitdepth: "color",
        }));
      } else {
        console.warn("WS not ready to send scan command", wsRef.current && wsRef.current.readyState);
        setToastMsg("Máy scan chưa sẵn sàng (WS chưa mở)");
        setGlobalLoading(false);
        setIsScanning(false);
        return;
      }

      // Start initial inactivity timer: wait up to 30s for first page
      if (initialTimerRef.current) clearTimeout(initialTimerRef.current);
      initialTimerRef.current = setTimeout(() => {
        initialTimerRef.current = null;
        // if still no pages, ask user whether to continue
        if (allImageUrls.length === 0) setShowConfirmPopup(true);
      }, 30000);
    } catch (err) {
      console.error(err);
      setToastMsg("Không thể bắt đầu scan");
      setGlobalLoading(false);
      setIsScanning(false);
    }
  };

  // finalize: upload collected images to backend and build documents from returned structure
  const finalizeUpload = async () => {
    if (!currentSession) return;
    if (!allImageUrls || allImageUrls.length === 0) {
      setGlobalLoading(false);
      return;
    }

    // clear any pending timers
    scanTimersRef.current.forEach((t) => clearTimeout(t));
    scanTimersRef.current = [];
    if (confirmTimerRef.current) {
      clearTimeout(confirmTimerRef.current);
      confirmTimerRef.current = null;
    }
    if (initialTimerRef.current) {
      clearTimeout(initialTimerRef.current);
      initialTimerRef.current = null;
    }

    setLoadingText("Đang upload ảnh lên server...");
    try {
      // mark finalizing so WS frames are ignored while we upload
      finalizingRef.current = true;

      // snapshot images to avoid race with incoming WS frames
      const snapshotImages = (imagesRef.current || []).slice();

      const formData = new FormData();

      // Prefer blobs cached from WS receive (imagesRef). This is more reliable
      // than re-fetching object URLs which could have been revoked.
      if (snapshotImages && snapshotImages.length === allImageUrls.length && snapshotImages.length > 0) {
        try {
          const totalBytes = snapshotImages.reduce((s, it) => s + ((it && it.blob && it.blob.size) || 0), 0);
          console.log(`WS: preparing upload of ${snapshotImages.length} files — total ${(totalBytes / (1024 * 1024)).toFixed(2)} MB`);
          snapshotImages.forEach((it, idx) => console.log(`  file ${idx + 1}: ${(((it && it.blob && it.blob.size) || 0) / (1024 * 1024)).toFixed(2)} MB`));
        } catch (e) { /* ignore logging errors */ }
        for (let i = 0; i < snapshotImages.length; i++) {
          const b = snapshotImages[i].blob;
          const file = new File([b], `scan-${i}.png`, { type: b.type || "image/png" });
          formData.append("files", file);
        }
      } else {
        // fallback: fetch each URL (works for server URLs and object URLs if still valid)
        for (let i = 0; i < allImageUrls.length; i++) {
          const url = allImageUrls[i];
          const resFetch = await fetch(url);
          if (!resFetch.ok) {
            throw new Error(`Failed to fetch image ${i} for upload (status ${resFetch.status})`);
          }
          const blob = await resFetch.blob();
          const file = new File([blob], `scan-${i}.png`, { type: blob.type || "image/png" });
          formData.append("files", file);
        }
      }

      // send upload; try once, then retry once on failure
      let res = await fetch(`https://api.ocr.cybertech.com.vn/sessions/${currentSession._id}/upload`, {
        method: "POST",
        body: formData,
      });
      let data = null;
      try { data = await res.json(); } catch (e) { data = null; }
      if (!res.ok) {
        console.error("Upload failed, retrying once", { status: res.status, body: data });
        // retry after short delay
        await new Promise((r) => setTimeout(r, 700));
        res = await fetch(`https://api.ocr.cybertech.com.vn/sessions/${currentSession._id}/upload`, {
          method: "POST",
          body: formData,
        });
        try { data = await res.json(); } catch (e) { data = null; }
      }

      if (!res.ok) {
        console.error("Upload final failure", { status: res.status, body: data });
        setToastMsg((data && data.detail) || `Upload thất bại (status ${res.status})`);
        setGlobalLoading(false);
        return;
      }

      const fullUrls = (data.new_files || []).map((path) => `https://api.ocr.cybertech.com.vn${path}`);
      setAllImageUrls(fullUrls);

      // revoke and clear cached object URLs/blobs from imagesRef (they are now on server)
      if (snapshotImages && snapshotImages.length) {
        snapshotImages.forEach((it) => {
          try { if (it && it.url) URL.revokeObjectURL(it.url); } catch (e) {}
        });
      }
      // clear the shared cache only if we uploaded the snapshot
      imagesRef.current = [];

      setLoadingText("Đang phân tích cấu trúc...");

      const structure = data.document_structure || [];
      const initialDocuments = structure.map((indices, idx) => ({
        doc_index: idx,
        indices: indices,
        fields: templateFields.map((f) => ({ ...f, value: "" })),
      }));

      // populate documents and preview
      setDocuments([]);
      setSelectedDocIndex(null);
      setSelectedImage(null);
      setLoadingText("Đang hiển thị tài liệu...");

      initialDocuments.forEach((doc, i) => {
        setTimeout(() => {
          setDocuments((prev) => {
            const newDocs = [...prev, doc];
            return newDocs.sort((a, b) => a.doc_index - b.doc_index);
          });
          if (i === 0 && doc.indices?.length > 0) {
            const firstImgIndex = doc.indices[0];
            setSelectedImage(fullUrls[firstImgIndex]);
            setSelectedDocIndex(doc.doc_index);
          }
          if (i === initialDocuments.length - 1) {
            setTimeout(() => setGlobalLoading(false), 500);
          }
        }, i * 300);
      });

      setToastMsg("Scan hoàn tất và upload thành công");
    } catch (err) {
      console.error(err);
      setToastMsg("Lỗi khi upload ảnh");
      setGlobalLoading(false);
    } finally {
      // clear finalizing state so WS can be processed normally again
      finalizingRef.current = false;
      setIsScanning(false);
    }
  };


  // ================== OCR ==================
  const handleOcr = async () => {
    if (!currentSession || !documents.length) {
      setToastMsg("Chưa có tài liệu để OCR");
      return;
    }
    const allFileIndices = documents.flatMap((doc) => doc.indices || []);
    if (allFileIndices.length === 0) return;

    setGlobalLoading(true);
    setLoadingText("Đang OCR toàn bộ tài liệu...");

    try {
      const res = await fetch("https://api.ocr.cybertech.com.vn/ocr/extract", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: currentSession._id,
          file_indices: allFileIndices,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setToastMsg(data.detail || "OCR thất bại");
        setGlobalLoading(false);
        return;
      }

      const processed = data.processed_groups || [];
      setDocuments((prevDocs) =>
        prevDocs.map((doc) => {
          const group = processed.find((g) => g.doc_group_index === doc.doc_index);
          if (!group || !group.extracted_data) return doc;

          const updates = group.extracted_data;
          const newFields = (doc.fields || []).map((f) => ({
            ...f,
            value: updates[f.key] ?? f.value ?? "",
          }));
          return { ...doc, fields: newFields };
        })
      );

      setFieldsEditable(false);
      setToastMsg("OCR thành công!");
      setOcrDone(true);
    } catch (err) {
      console.error(err);
      setToastMsg("Lỗi kết nối khi OCR");
    } finally {
      setGlobalLoading(false);
    }
  };

  const switchOcrMode = async (mode) => {
    try {
      const res = await fetch(`https://api.ocr.cybertech.com.vn/system/switch-mode?mode=${mode}`, { method: "POST" });
      const data = await res.json();
      if (!res.ok) return null;
      setOcrMode(data.current_mode || mode);
      setToastMsg(data.message || `Đã chuyển mode ${mode}`);
      return data;
    } catch (err) {
      return null;
    }
  };

  const handleOcrVip = async () => {
    if (!currentSession || !documents.length) return; // Kiểm tra xem đã có session và tài liệu hay chưa

    // Đổi chế độ OCR giữa 'default' và 'vip' mà không thực hiện OCR
    const newMode = ocrMode === "default" ? "vip" : "default"; // Toggle giữa default và vip
    const switched = await switchOcrMode(newMode); // Gọi API để đổi chế độ OCR

    if (switched) {
      setOcrMode(newMode); // Cập nhật trạng thái chế độ OCR
      setToastMsg(`Chế độ OCR đã chuyển sang: ${newMode === "vip" ? "VIP" : "DEFAULT"}`); // Thông báo chế độ đã đổi
    }
  };

  // ================== EDIT / SAVE INDEX ==================
  const currentDoc = documents.find((d) => d.doc_index === selectedDocIndex) || null;

  const handleEditOrSave = async () => {
    if (!currentSession) return;
    const doc = documents.find((d) => d.doc_index === selectedDocIndex) || documents[0];
    if (!doc) {
      setToastMsg("Hãy chọn tài liệu để sửa");
      return;
    }

    if (!fieldsEditable) {
      setFieldsEditable(true);
      return;
    }

    const updates = {};
    (doc.fields || []).forEach((f) => {
      if (!f.key) return;
      updates[f.key] = f.value ?? "";
    });

    try {
      const res = await fetch(
        `https://api.ocr.cybertech.com.vn/sessions/${currentSession._id}/ocr`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            doc_index: doc.doc_index,
            updates,
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        setToastMsg(data.detail || "Lỗi khi lưu");
        return;
      }
      setFieldsEditable(false);
      setToastMsg("Lưu thành công");
    } catch (err) {
      setToastMsg("Lỗi kết nối");
    }
  };

  const handleExport = async () => {
    if (!currentSession || !ocrDone) {
      setToastMsg("Cần OCR trước khi xuất!");
      return;
    }
    setGlobalLoading(true);
    setLoadingText("Đang xuất Paperless...");
    try {
      const res = await fetch(
        `https://api.ocr.cybertech.com.vn/sessions/${currentSession._id}/upload-paperless`,
        { method: "POST" }
      );
      const data = await res.json();
      if (!res.ok) {
        setToastMsg(data.detail || "Lỗi xuất file");
      } else {
        setToastMsg("Xuất thành công!");
      }
    } catch (err) {
      setToastMsg("Lỗi kết nối");
    } finally {
      setGlobalLoading(false);
    }
  };

  const handleResetSession = () => {
    setCurrentSession(null);
    setDocuments([]);
    setAllImageUrls([]);
    setSelectedImage(null);
    setSelectedDocIndex(null);
    setFieldsEditable(false);
    setTemplateFields([]);
    setIsScanning(false);
    setGlobalLoading(false);
    setToastMsg("Đã làm mới");
  };

  const armInactivityTimer = () => {
    // Không đếm khi đang scan hoặc đang loading
    if (isScanning || globalLoading) return;

    if (confirmTimerRef.current) {
      clearTimeout(confirmTimerRef.current);
    }

    confirmTimerRef.current = setTimeout(() => {
      confirmTimerRef.current = null;
      setShowConfirmPopup(true);
    }, 2000);
  };

  // Helpers
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) setShowDropdown(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchCurrentMode = async () => {
      try {
        const res = await fetch("https://api.ocr.cybertech.com.vn/system/current-mode");
        const data = await res.json();
        if (res.ok && data.mode) setOcrMode(data.mode);
      } catch (err) { }
    };
    fetchCurrentMode();
  }, []);

  // Initialize WebSocket connection to scanner server
  useEffect(() => {
    let mounted = true;
    let reconnectTimer = null;

    const connect = () => {
      if (!mounted) return;
      if (wsRef.current) return;

      try {
        // attach token as query param to allow server auth (some servers expect this)
        const urlWithToken = WS_URL.includes("?") ? `${WS_URL}&token=${encodeURIComponent(WS_TOKEN)}` : `${WS_URL}?token=${encodeURIComponent(WS_TOKEN)}`;
        const ws = new WebSocket(urlWithToken);
        wsRef.current = ws;
        setWsConnected(false);

        ws.onopen = () => {
          if (!mounted) return;
          setWsConnected(true);
          try {
            ws.send(JSON.stringify({ type: "list_devices", token: WS_TOKEN }));
          } catch (e) { console.warn('WS send list_devices failed', e); }
        };

        ws.onmessage = (ev) => {
          try {
            const msg = JSON.parse(ev.data);
            // If we're finalizing (uploading/closing), ignore incoming frames to avoid race
            if (finalizingRef.current) {
              console.warn("WS: ignoring incoming frame while finalizing/uploading");
              return;
            }
            if (msg.type === "devices") {
              if (msg.ok) setDevices(msg.devices || []);
              return;
            }
            if (msg.type === "hello") return;

            if (msg.type === "done") {
              if (!msg.ok) {
                setToastMsg(msg.error || "Scan lỗi");
                return;
              }

              if (msg.base64) {
                const contentType = msg.content_type || "image/png";
                const bstr = atob(msg.base64);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) u8arr[n] = bstr.charCodeAt(n);
                const blob = new Blob([u8arr], { type: contentType });
                const url = URL.createObjectURL(blob);

                // cache blob+url for upload and append url for preview
                imagesRef.current.push({ blob, url });
                // log received image size in MB
                try {
                  const recvIdx = imagesRef.current.length - 1;
                  const mb = ((blob && blob.size) || 0) / (1024 * 1024);
                  console.log(`WS: received image #${recvIdx + 1} size=${mb.toFixed(2)} MB`);
                } catch (e) { /* ignore logging errors */ }

                // Append to image list and maintain a temporary document view so
                // paused/stopped sessions can still display collected pages.
                setAllImageUrls((prev) => {
                  const prevLen = prev.length;
                  const newArr = [...prev, url];

                  // update documents: if none exist, create a temp single document
                  setDocuments((prevDocs) => {
                    if (!prevDocs || prevDocs.length === 0) {
                      // Only include the newly appended index to avoid showing multiple
                      // pages at once when a single page is scanned.
                      const newIndex = prevLen; // index of the newly added url
                      const tempDoc = {
                        doc_index: 0,
                        indices: [newIndex],
                        fields: (templateFields || []).map((f) => ({ ...f, value: "" })),
                      };
                      setSelectedDocIndex(0);
                      // ensure preview shows latest
                      setSelectedImage(url);
                      return [tempDoc];
                    }

                    // otherwise append the new page to the last document
                    const copy = prevDocs.map((d) => ({ ...d, indices: [...(d.indices || [])] }));
                    const last = copy[copy.length - 1];
                    const pageIndex = newArr.length - 1;
                    if (!last.indices.includes(pageIndex)) {
                      last.indices.push(pageIndex);
                    }
                    // show preview of the new page
                    setSelectedDocIndex(copy[copy.length - 1].doc_index);
                    setSelectedImage(url);
                    return copy;
                  });

                  // record last page received time
                  lastPageAtRef.current = Date.now();
                  // clear initial timer (we received first page)
                  if (initialTimerRef.current) {
                    clearTimeout(initialTimerRef.current);
                    initialTimerRef.current = null;
                  }
                  // schedule inactivity check: show popup only if no new page arrives for 2s
                  const scheduleInactivityCheck = () => {
                    if (confirmTimerRef.current) {
                      clearTimeout(confirmTimerRef.current);
                      confirmTimerRef.current = null;
                    }
                    const check = () => {
                      const elapsed = Date.now() - (lastPageAtRef.current || 0);
                      if (elapsed >= 2000) {
                        confirmTimerRef.current = null;
                        setShowConfirmPopup(true);
                      } else {
                        confirmTimerRef.current = setTimeout(check, 2000 - elapsed);
                      }
                    };
                    confirmTimerRef.current = setTimeout(check, 2000);
                  };
                  scheduleInactivityCheck();

                  return newArr;
                });
              }
            }
          } catch (err) {
            console.error("WS parse error", err);
          }
        };

        ws.onclose = (ev) => {
          console.warn("WS closed", ev);
          setWsConnected(false);
          // clear reference so connect() can reopen
          if (wsRef.current === ws) wsRef.current = null;
          if (mounted) {
            // try reconnect after delay
            reconnectTimer = setTimeout(connect, 1500);
          }
        };

        ws.onerror = (e) => {
          console.error("WS error", e);
          setWsConnected(false);
          // error may be followed by close; ensure ref cleared
          try { if (wsRef.current === ws) wsRef.current = null; } catch (e) {}
        };
      } catch (err) {
        console.error("WS init error", err);
        if (mounted) reconnectTimer = setTimeout(connect, 1500);
      }
    };

    connect();

    return () => {
      mounted = false;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try { if (wsRef.current) wsRef.current.close(); } catch (e) {}
      wsRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!selectedImage || !wrapperRef.current || !imageRef.current) return;
    const wrapWidth = wrapperRef.current.clientWidth;
    const imgWidth = imageRef.current.naturalWidth;
    setPos({ x: (wrapWidth - imgWidth) / 2, y: 0 });
  }, [selectedImage]);

  // Cleanup any pending timers on unmount
  useEffect(() => {
    return () => {
      scanTimersRef.current.forEach((t) => clearTimeout(t));
      if (confirmTimerRef.current) clearTimeout(confirmTimerRef.current);
      if (initialTimerRef.current) clearTimeout(initialTimerRef.current);
    };
  }, []);

  const cancelContinueScan = () => {
    // User cancels continuation — pause scanning but keep collected pages
    setShowConfirmPopup(false);
    pendingInitialDocsRef.current = null;
    fullUrlsRef.current = [];
    // attempt to politely stop scanner (if supported)
    try {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({ type: "stop", token: WS_TOKEN, device: selectedDevice }));
      }
    } catch (e) { /* ignore */ }
    // clear any timers that could reopen the popup or keep loading
    try { if (confirmTimerRef.current) { clearTimeout(confirmTimerRef.current); confirmTimerRef.current = null; } } catch (e) {}
    try { if (initialTimerRef.current) { clearTimeout(initialTimerRef.current); initialTimerRef.current = null; } } catch (e) {}
    lastPageAtRef.current = 0;
    setIsScanning(false);
    setIsPaused(true);
    setGlobalLoading(false);
    setLoadingText("");
    setToastMsg("Đã tạm dừng scan. Nhấn Scan để tiếp tục.");
  };

const confirmContinueScan = () => {
    setShowConfirmPopup(false);

    // Clear inactivity timer ngay
    if (confirmTimerRef.current) {
      clearTimeout(confirmTimerRef.current);
      confirmTimerRef.current = null;
    }

    setIsScanning(true);
    setGlobalLoading(true);
    setLoadingText("Đang tiếp tục scan...");

    // resume from pause
    setIsPaused(false);
    if (wsRef.current && wsConnected) {
      try {
        wsRef.current.send(JSON.stringify({
          type: "scan",
          token: WS_TOKEN,
          device: selectedDevice,
          source: "glass",
          dpi: 200,
          bitdepth: "color",
        }));
      } catch (err) {
        console.error("WS send error", err);
        setToastMsg("Không thể gửi lệnh tiếp tục scan");
      }
    } else {
      setToastMsg("Máy scan chưa kết nối");
    }
  };

  return (
    <div className="scan-container">
      {/* Toolbar - Giữ nguyên như cũ */}
      <div className="toolbar">
        <div className="toolbar-left">
          <div className="dropdown">
            <button className="btn dropdown-toggle" onClick={() => setShowDropdown(!showDropdown)}>
              <img src="/icons/icons8-template-100.png" className="btn-icon" alt="" /> Template
            </button>
            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-item" onClick={() => { setShowDropdown(false); setOpenModal(true); }}>Chọn Template</div>
                <div className="dropdown-item" onClick={() => { setShowDropdown(false); setOpenCreateModal(true); }}>Tạo Template</div>
                <div className="dropdown-item" onClick={() => { setShowDropdown(false); setOpenManagerModal(true); }}>Quản lý Template</div>
              </div>
            )}
          </div>
          {/* Device selector for scanner WS */}
          <div style={{ display: 'inline-block', marginLeft: 12 }}>
            <select value={selectedDevice} onChange={(e) => setSelectedDevice(e.target.value)} style={{ padding: '8px 10px' }}>
              <option value="">{wsConnected ? "-- Chọn máy scan --" : "Đang kết nối scanner..."}</option>
              {devices.map((d, i) => <option key={i} value={d}>{d}</option>)}
            </select>
            <span style={{ marginLeft: 8, fontSize: 12, color: wsConnected ? '#1890ff' : '#999' }}>{wsConnected ? 'WS connected' : 'WS offline'}</span>
          </div>
          {currentSession && (
            <button className="btn ai" onClick={handleScan} disabled={isScanning}>
              <img src="/icons/icons8-scan-100.png" className="btn-icon" alt="" /> {isScanning ? "Scanning..." : "Scan tài liệu"}
            </button>
          )}
          {currentSession && documents.length > 0 && (
            <button className="btn ai" onClick={handleOcr}>
              <img src="/icons/icons8-ocr-100.png" className="btn-icon" alt="" />
              {ocrMode === "default" ? "OCR MODE DEFAULT" : "OCR MODE VIP"}
            </button>
          )}
          {ocrDone && (
            <button className="btn" onClick={handleEditOrSave}>
              <img src={fieldsEditable ? "/icons/icons8-save-100.png" : "/icons/icons8-edit-100.png"} className="btn-icon" alt="" />
              {fieldsEditable ? "Lưu kết quả" : "Sửa chỉ mục"}
            </button>
          )}
        </div>
        <div className="toolbar-right">
          {currentSession && documents.length > 0 && (
            <button className="btn ai" onClick={handleOcrVip}>
              <img src="/icons/icons8-ocr-100.png" className="btn-icon" alt="" /> ĐỔI MODE OCR
            </button>
          )}
          <button className="btn export" onClick={handleExport}>
            <img src="/icons/icons8-upload-100.png" className="btn-icon" alt="" /> Xuất kết quả
          </button>
          <button className="btn danger" onClick={handleResetSession}>
            <img src="/icons/icons8-refresh-100.png" className="btn-icon" alt="" /> Làm mới
          </button>
        </div>
      </div>

      <div className="layout">
        {/* ============ CỘT TRÁI: DANH SÁCH TÀI LIỆU (DRAG & DROP) ============ */}
        <div className="panel left-panel">
          <div className="panel-header">Danh sách tài liệu</div>
          <div className="panel-body">
            {documents.length === 0 ? (
              <p className="placeholder-text">Chưa có dữ liệu</p>
            ) : (
              // Bọc toàn bộ vùng kéo thả bằng DragDropContext
              <DragDropContext onDragEnd={onDragEnd}>
                <ul className="doc-tree">
                  {documents.map((doc) => (
                    <li key={doc.doc_index}>
                      {/* Tiêu đề Document */}
                      <div
                        style={{
                          fontWeight: selectedDocIndex === doc.doc_index ? "bold" : "normal",
                          cursor: "pointer",
                          padding: "5px 0",
                        }}
                        onClick={() => setSelectedDocIndex(doc.doc_index)}
                      >
                        📁 Tài liệu {doc.doc_index + 1}
                      </div>

                      {/* Vùng thả (Droppable) cho từng tài liệu */}
                      <Droppable droppableId={`doc-${doc.doc_index}`}>
                        {(provided, snapshot) => (
                          <ul
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              minHeight: "10px", // Để dễ thả vào nếu doc trống
                              background: snapshot.isDraggingOver ? "#f0f0f0" : "transparent",
                              paddingLeft: "20px"
                            }}
                          >
                            {/* Danh sách các trang (Draggable) */}
                            {(doc.indices || []).map((imgIndex, pagePos) => {
                              const isSelected = selectedImage === allImageUrls[imgIndex];
                              const uniqueKey = `${doc.doc_index}-${pagePos}-${imgIndex}`;
                              const dragId = `page-${doc.doc_index}-${pagePos}-${imgIndex}`;
                              return (
                                <Draggable
                                  key={uniqueKey}
                                  draggableId={dragId}
                                  index={pagePos}
                                >
                                  {(provided, snapshot) => (
                                    <li
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      onClick={() => {
                                        setSelectedDocIndex(doc.doc_index);
                                        setSelectedImage(allImageUrls[imgIndex]);
                                      }}
                                      style={{
                                        ...provided.draggableProps.style,
                                        cursor: "pointer",
                                        padding: "4px 8px",
                                        // Logic Highlight: Bold + Màu nền nếu đang chọn
                                        fontWeight: isSelected ? "bold" : "normal",
                                        color: isSelected ? "#1890ff" : "inherit",
                                        borderRadius: "4px",
                                        marginBottom: "2px",
                                        border: snapshot.isDragging ? "1px dashed #faad14" : "none"
                                      }}
                                    >
                                      📄 Trang {pagePos + 1}
                                    </li>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </li>
                  ))}
                </ul>
                {/* === THÊM VÙNG NÀY Ở DƯỚI CÙNG DANH SÁCH === */}
                <Droppable droppableId="create-new-doc">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className={`new-doc-zone ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                    >
                      {snapshot.isDraggingOver ? (
                        <span>✨ Thả vào đây để tạo Tài liệu mới</span>
                      ) : (
                        <span>+ Kéo trang vào đây để tách thành Tài liệu mới</span>
                      )}
                      {/* Placeholder ẩn cần thiết cho dnd hoạt động */}
                      <div style={{ display: 'none' }}>{provided.placeholder}</div>
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </div>
        </div>

        {/* Cột giữa: Xem tài liệu (Giữ nguyên) */}
        <div className="panel center-panel" ref={wrapperRef}>
          <div className="panel-header">Xem tài liệu</div>
          <TransformWrapper initialScale={1} centerOnInit={true} wheel={{ step: 0.2 }} doubleClick={{ disabled: true }}>
            {() => (
              <div className="center-panel">
                <div className="preview-wrapper">
                  <TransformComponent>
                    {selectedImage && (
                      <img ref={imageRef} src={selectedImage} alt="" className="preview-image" />
                    )}
                  </TransformComponent>
                </div>
              </div>
            )}
          </TransformWrapper>
        </div>

        {/* Cột phải: Chỉ mục (Giữ nguyên logic hiển thị) */}
        <div className="panel right-panel">
          <div className="panel-header">
            Danh sách chỉ mục
            {currentDoc && (
              <span style={{ fontSize: 12, marginLeft: 8, color: "#666" }}>
                (Tài liệu {currentDoc.doc_index + 1})
              </span>
            )}
          </div>

          <div className="indexes-container">
            {selectedDocIndex !== null && currentDoc && currentDoc.fields ? (
              currentDoc.fields.map((field, idx) => (
                <div key={idx} className="index-row">
                  <div className="index-label">{field.description}</div>
                  <textarea
                    className="index-textarea"
                    disabled={!fieldsEditable}
                    value={field.value || ""}
                    onChange={(e) => {
                      if (!fieldsEditable) return;
                      const value = e.target.value;
                      setDocuments((prev) =>
                        prev.map((doc) => {
                          if (doc.doc_index !== currentDoc.doc_index) return doc;
                          const newFields = doc.fields.map((f, i) =>
                            i === idx ? { ...f, value } : f
                          );
                          return { ...doc, fields: newFields };
                        })
                      );
                    }}
                  />
                </div>
              ))
            ) : templateFields.length > 0 ? (
              templateFields.map((field, idx) => (
                <div key={idx} className="index-row">
                  <div className="index-label">{field.description}</div>
                  <textarea className="index-textarea" disabled={true} value={""} />
                </div>
              ))
            ) : (
              <p className="placeholder-text">Hãy chọn template để bắt đầu</p>
            )}
          </div>
        </div>
      </div>

      <TemplateModal open={openModal} onClose={() => setOpenModal(false)} onSubmit={handleSelectTemplate} />
      <TemplateManagerModal open={openManagerModal} onClose={() => setOpenManagerModal(false)} />
      <CreateTemplateModal
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        onSaved={() => { setToastMsg("Tạo template thành công"); }}
      />
      {/* Confirm popup shown when first page scanned but rest not seen */}
      {showConfirmPopup && createPortal(
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2147483647 }}>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, width: 380, boxShadow: '0 6px 18px rgba(0,0,0,0.2)' }}>
            <div style={{ marginBottom: 12, fontWeight: 600 }}>Không thấy scan tiếp tục</div>
            <div style={{ marginBottom: 18 }}>Bạn có muốn tiếp tục scan không?</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button className="btn" onClick={cancelContinueScan}>Hủy</button>
              <button className="btn ai" onClick={confirmContinueScan}>Tiếp tục</button>
            </div>
          </div>
        </div>,
        document.body
      )}
      {globalLoading && (
        <div className="global-loading-overlay">
          <div className="global-loading-box">
            <div className="global-spinner"></div>
            <div className="global-loading-text">{loadingText}</div>
          </div>
        </div>
      )}
      <Toast message={toastMsg} onClose={() => setToastMsg("")} />
    </div>
  );
}